import { ca } from '@cian/analytics';

import { EDeviceType } from '../../types/device';
import { IFavoriteEntity } from '../../types/results';
import { EOfferType, getCustomUrl, getPageNumber } from '../../utils/trackings';

interface IParameters {
  offer: IFavoriteEntity;
  position: number;
  total: number | null;
  deviceType: EDeviceType;
}

export function trackModalOpen({ offer, position, total, deviceType }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label: getCustomUrl(offer),
    page: {
      pageType: 'ListingFavorites',
      listingType: 'list',
      offersQty: total,
      pageNumber: total && getPageNumber(total, position),
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        owner_id: offer.agentInfo?.id,
      },
    },
    products: [
      {
        id: offer.entityId,
        offerType: EOfferType.Offer,
        position,
        published: offer.status === 'published',
      },
    ],
  });
}
